import _JSXStyle from "styled-jsx/style";
import { colors, spacers } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
const flipMargin = margin => {
  const splitMargin = margin.split(/\s+/);
  if ((splitMargin === null || splitMargin === void 0 ? void 0 : splitMargin.length) === 4) {
    return [splitMargin[0], splitMargin[3], splitMargin[2], splitMargin[1]].join(' ');
  }
  return margin;
};
const Divider = _ref => {
  let {
    className,
    dataTest = 'dhis2-uicore-divider',
    dense,
    margin = `${spacers.dp8} 0`
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    role: "separator",
    className: _JSXStyle.dynamic([["2418722155", [colors.grey300]], ["3247041537", [dense ? `${spacers.dp4} 0` : margin, dense ? `${spacers.dp4} 0` : flipMargin(margin)]]]) + " " + (className || "")
  }, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2418722155",
    dynamic: [colors.grey300]
  }, [`div.__jsx-style-dynamic-selector{display:inline-block;width:100%;height:1px;background-color:${colors.grey300};}`]), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3247041537",
    dynamic: [dense ? `${spacers.dp4} 0` : margin, dense ? `${spacers.dp4} 0` : flipMargin(margin)]
  }, [`div.__jsx-style-dynamic-selector{margin:${dense ? `${spacers.dp4} 0` : margin};}`, `.__jsx-style-dynamic-selector:dir(rtl){margin:${dense ? `${spacers.dp4} 0` : flipMargin(margin)};}`]));
};
Divider.propTypes = {
  className: PropTypes.string,
  dataTest: PropTypes.string,
  dense: PropTypes.bool,
  margin: PropTypes.string
};
export { Divider };